//rules.js
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import seedImg from '../assets/seed.png';
import saplingImg from '../assets/sapling.png';
import treeImg from '../assets/tree.png';
import batteryImg from '../assets/battery.png';
import bloomImg from '../assets/bloom.png';
import engineerImg from '../assets/engineer.png';
import explorerImg from '../assets/explorer.png';
import factoryImg from '../assets/factory.png';
import forestImg from '../assets/forest.png';
import gardenImg from '../assets/garden.png';
import loveImg from '../assets/love.png';
import materialsImg from '../assets/materials.png';
import meditationImg from '../assets/meditation.png';
import naturalistImg from '../assets/naturalist2.png';
import observationImg from '../assets/observation.png';
import patienceImg from '../assets/patience.png';
import settlementImg from '../assets/settlement.png';
import solarPanelImg from '../assets/solar.png';
import thrivingCivilizationImg from '../assets/thrivingCivilization.png';
import thrivingEcosystemImg from '../assets/thrivingEcosystem.png';
import toolsImg from '../assets/tools.png';
import windTurbineImg from '../assets/windturbine2.png';
import habitatImg from '../assets/habitat.png';
import oasisImg from '../assets/oasis.png';
import communityImg from '../assets/community.png';
import curiosityImg from '../assets/curiosity.png';
import scavengerImg from '../assets/scavenger.png';
import futuristImg from '../assets/futurist.png';
import farmImg from '../assets/farm.png';
import nuclearImg from '../assets/nuclear.png';
import physicistImg from '../assets/physicist.png';
import unchartedImg from '../assets/uncharted.png';
import cityImg from '../assets/city.png';
import thrivingSpiritImg from '../assets/thrivingSpirit.png';
import recycleImg from '../assets/recycle.png';
import libraryImg from '../assets/library.png';


export const CARD_IDS = {
  // Wisdom cards
  MEDITATION: 'w-1',
  PATIENCE: 'w-2',
  LOVE: 'w-3',
  CURIOSITY: 'w-4',
  ENGINEER: 'w-5',
  PHYSICIST: 'w-6',
  NATURALIST: 'w-7',
  OBSERVATION: 'w-8',
  EXPLORER: 'w-9',
  SCAVENGER: 'w-10',
  FUTURIST: 'w-11',
  COMMUNITY: 'w-12',
  THRIVING_SPIRIT: 'w-13',
  LIBRARY: 'w-14',
  
  
  // Eco cards
  SEED: 'e-1',
  SAPLING: 'e-2',
  TREE: 'e-3',
  FOREST: 'e-4',
  GARDEN: 'e-5',
  FARM: 'e-6',
  HABITAT: 'e-7',
  OASIS: 'e-10',
  BLOOM: 'e-11',
  THRIVING_ECOSYSTEM: 'e-12',
  UNCHARTED: 'e-13',
  
  // Tech cards
  MATERIALS: 't-1',
  TOOLS: 't-2',
  BATTERY: 't-3',
  SOLAR_PANEL: 't-4',
  WIND_TURBINE: 't-5',
  NUCLEAR_ENERGY: 't-6',
  SETTLEMENT: 't-7',
  FACTORY: 't-8',
  THRIVING_CIVILIZATION: 't-9',
  CITY: 't-10',
  RECYCLE: 't-11',
};

export const CARD_RARITY = {
  COMMON: 'common', // Default 3 copies max
  SPECIAL: 'special' // Only 1 copy allowed
};

export const availableCards = [
  // Wisdom cards
  
   {
	   id: CARD_IDS.LIBRARY,
	   name: 'Library',
	   type: 'Wisdom',
	   energy: 2,
	   imageUrl: libraryImg,
	   description: 'Add a wisdom card from your deck. bonus for each Curiosity card played.',
	   rarity: CARD_RARITY.COMMON
	 },
	  {id: CARD_IDS.MEDITATION , name: 'Meditation', type: 'Wisdom', energy: 3, imageUrl: meditationImg, description: '+3 energy', rarity: CARD_RARITY.COMMON},
	{id: CARD_IDS.PATIENCE, name: 'Patience', type: 'Wisdom', energy: 1, imageUrl: patienceImg, description: '+1 energy. Requires meditation', rarity: CARD_RARITY.COMMON},
	   {id: CARD_IDS.LOVE, name: 'Love', type: 'Wisdom', energy: 5, imageUrl: loveImg, description: '+5 energy, +1 space. Requires patience.', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.CURIOSITY, name: 'Curiosity', type: 'Wisdom', energy: 2, imageUrl: curiosityImg, description: '+2 energy', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.ENGINEER, name: 'Engineer', type: 'Wisdom', energy: 0, imageUrl: engineerImg, description: 'Build advanced technology.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.PHYSICIST, name: 'Physicist', type: 'Wisdom', energy: 0, imageUrl: physicistImg, description: 'Build advanced technology. Requires curiosity.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.NATURALIST, name: 'Naturalist', type: 'Wisdom', energy: 0, imageUrl: naturalistImg, rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.OBSERVATION, name: 'Observation', type: 'Wisdom', energy: 0, imageUrl: observationImg, description: 'Draw 2 cards.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.COMMUNITY, name: 'Community', type: 'Wisdom', energy: 5, imageUrl: communityImg, description: '+5 energy, +2 spaces, +1 hand. Requires garden or love.', rarity: CARD_RARITY.COMMON },
	 
	  {id: CARD_IDS.EXPLORER, name: 'Explorer', type: 'Wisdom', energy: -5, imageUrl: explorerImg, description: '-5 energy, draw 3 cards. Requires curiosity.', rarity: CARD_RARITY.COMMON},
	  
	  {id: CARD_IDS.SCAVENGER, name: 'Scavenger', type: 'Wisdom', energy: 0, imageUrl: scavengerImg, description: 'Move two cards from the discard pile into your hand.', rarity: CARD_RARITY.COMMON },
	  
	  {id: CARD_IDS.RECYCLE,
		name: 'Recycle',
		type: 'Tech',
		energy: -5,
		imageUrl: recycleImg,
		description: '-5 energy. Choose technology cards from discard to recycle. Get a materials card for each. Requires energy source and scavenger.', rarity: CARD_RARITY.COMMON
	  },
	  {id: CARD_IDS.FUTURIST, name: 'Futurist', type: 'Wisdom', energy: 0, imageUrl: futuristImg, description: 'Select a card from your deck and put it into your hand.', rarity: CARD_RARITY.COMMON },
	  { id: CARD_IDS.THRIVING_SPIRIT,
		  name: 'Thriving Spirit', 
		  type: 'Wisdom', 
		  energy: 0, 
		  imageUrl: thrivingSpiritImg, 
		  description: 'Pick 2 cards from discard pile and 2 from deck. +1 space. Requires curiosity and love.', rarity: CARD_RARITY.SPECIAL
		},
	 
	 // Ecology cards
	  {id: CARD_IDS.SEED, name: 'Seed', type: 'Eco', energy: 0, imageUrl: seedImg, rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.SAPLING, name: 'Sapling', type: 'Eco', energy: 1, imageUrl: saplingImg, description: '+1 energy, Requires seed', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.TREE, name: 'Tree', type: 'Eco', energy: 3, imageUrl: treeImg, description: '+3 energy. Requires sapling or seed and patience.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.FOREST, name: 'Forest', type: 'Eco', energy: 10, imageUrl: forestImg, description: '+10 energy. Requires tree.', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.GARDEN, name: 'Garden', type: 'Eco', energy: 5, imageUrl: gardenImg, description: '+5 energy. Requires naturalist and seed or seed and patience.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.FARM, name: 'Farm', type: 'Eco', energy: 7, imageUrl: farmImg, description: '+7 energy. Requires Community.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.HABITAT, name: 'Habitat', type: 'Eco', energy: 1, imageUrl: habitatImg, description: '+1 energy +2 spaces. Requires naturalist or forest.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.OASIS, name: 'Oasis', type: 'Eco', energy: 5, imageUrl: oasisImg, description: '+5 energy, + 3 spaces. Requires Explorer with patience or naturalist.', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.BLOOM, name: 'Bloom', type: 'Eco', energy: 0, imageUrl: bloomImg, description: 'Adds a sapling, tree, forest, and wildflowers to deck. Requires tree', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.THRIVING_ECOSYSTEM, name: 'Thriving Ecosystem', type: 'Eco', energy: 15, imageUrl: thrivingEcosystemImg, description: '+15 energy. Requires forest and love. Adds bloom card to deck.', rarity: CARD_RARITY.SPECIAL},
	  {id: CARD_IDS.UNCHARTED, name: 'Uncharted', type: 'Eco', energy: 0, imageUrl: unchartedImg, description: '+2 spaces. Adds 2 random cards to the deck. Requires explorer.', rarity: CARD_RARITY.COMMON },
	  // Technology cards
	  {id: CARD_IDS.MATERIALS, name: 'Materials', type: 'Tech', energy: -5, imageUrl: materialsImg, description: '-5 energy. Required to build', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.TOOLS, name: 'Tools', type: 'Tech', energy: 0, imageUrl: toolsImg, description: 'Required to build', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.BATTERY, name: 'Battery', type: 'Tech', energy: 0, imageUrl: batteryImg, description: 'Requires materials and tools', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.SOLAR_PANEL, name: 'Solar Panel', type: 'Tech', energy: 7, imageUrl: solarPanelImg, description: '+7 energy. Requires battery and engineer', rarity: CARD_RARITY.COMMON },
	  {id: CARD_IDS.WIND_TURBINE, name: 'Wind Turbine', type: 'Tech', energy: 5, imageUrl: windTurbineImg, description: '+5 energy. Requires battery and engineer', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.NUCLEAR_ENERGY, name: 'Nuclear Energy', type: 'Tech', energy: 10, imageUrl: nuclearImg, description: '+10 energy. Requires battery, engineer, and physicist', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.SETTLEMENT, name: 'Settlement', type: 'Tech', energy: -5, imageUrl: settlementImg, description: '-5 energy, +5 spaces. Requires energy source or farm.', rarity: CARD_RARITY.COMMON},
	  {id: CARD_IDS.FACTORY, name: 'Factory', type: 'Tech', energy: -10, imageUrl: factoryImg, description: '-10 energy. Build 3 cards for every material card played. Requires Settlement', rarity: CARD_RARITY.COMMON},
	  { id: CARD_IDS.CITY,
		  name: 'City', 
		  type: 'Tech', 
		  energy: 0, 
		  imageUrl: cityImg, 
		  description: '+5 spaces. Requires factory, community or settlement, and 2 different energy sources.', rarity: CARD_RARITY.COMMON
		},
	  {id: CARD_IDS.THRIVING_CIVILIZATION, name: 'Thriving Civilization', type: 'Tech', energy: 0, imageUrl: thrivingCivilizationImg, description: ' +10 spaces. Adds a factory and city to deck. Requires city and love.', rarity: CARD_RARITY.SPECIAL },
   
];

// eslint-disable-next-line no-unused-vars
const starterDeck = [
  // Eco cards
  { name: 'Seed', type: 'Eco', energy: 0, imageUrl: seedImg },
  { name: 'Seed', type: 'Eco', energy: 0, imageUrl: seedImg },
  { name: 'Seed', type: 'Eco', energy: 0, imageUrl: seedImg },
  { name: 'Sapling', type: 'Eco', energy: 1, imageUrl: saplingImg, description: '+1 energy. Requires seed' },
  { name: 'Sapling', type: 'Eco', energy: 1, imageUrl: saplingImg, description: '+1 energy. Requires seed' },
  { name: 'Sapling', type: 'Eco', energy: 1, imageUrl: saplingImg, description: '+1 energy. Requires seed' },
  { name: 'Tree', type: 'Eco', energy: 3, imageUrl: treeImg, description: '+3 energy. Requires sapling or seed and patience.' },
  { name: 'Tree', type: 'Eco', energy: 3, imageUrl: treeImg, description: '+3 energy. Requires sapling or seed and patience.' },
  { name: 'Tree', type: 'Eco', energy: 3, imageUrl: treeImg, description: '+3 energy. Requires sapling or seed and patience.' },
  { name: 'Forest', type: 'Eco', energy: 10, imageUrl: forestImg, description: '+10 energy. Requires tree.' },
  { name: 'Forest', type: 'Eco', energy: 10, imageUrl: forestImg, description: '+10 energy. Requires tree.' },
  { name: 'Forest', type: 'Eco', energy: 10, imageUrl: forestImg, description: '+10 energy. Requires tree.' },
  { name: 'Garden', type: 'Eco', energy: 5, imageUrl: gardenImg, description: '+5 energy. Requires naturalist and seed or seed and patience.' },
  { name: 'Garden', type: 'Eco', energy: 5, imageUrl: gardenImg, description: '+5 energy. Requires naturalist and seed or seed and patience.' },
  { name: 'Farm', type: 'Eco', energy: 7, imageUrl: farmImg, description: '+7 energy. Requires Community.' },
  { name: 'Habitat', type: 'Eco', energy: 1, imageUrl: habitatImg, description: '+1 energy +2 spaces. Requires naturalist or forest.' },
  { name: 'Habitat', type: 'Eco', energy: 1, imageUrl: habitatImg, description: '+1 energy +2 spaces. Requires naturalist or forest.' },
  { name: 'Oasis', type: 'Eco', energy: 5, imageUrl: oasisImg, description: '+5 energy, +3 spaces. Requires Explorer with patience or naturalist.' },
  { name: 'Bloom', type: 'Eco', energy: 0, imageUrl: bloomImg, description: 'Adds a sapling, tree, forest, and wildflowers to deck. Requires tree' },
  { name: 'Bloom', type: 'Eco', energy: 0, imageUrl: bloomImg, description: 'Adds a sapling, tree, forest, and wildflowers to deck. Requires tree' },
  { name: 'Thriving Ecosystem', type: 'Eco', energy: 15, imageUrl: thrivingEcosystemImg, description: '+15 energy. Requires forest and love. Adds bloom card to deck.' },
  // Technology cards
  { name: 'Materials', type: 'Tech', energy: -5, imageUrl: materialsImg, description: '-5 energy. Required to build' },
  { name: 'Materials', type: 'Tech', energy: -5, imageUrl: materialsImg, description: '-5 energy. Required to build' },
  { name: 'Materials', type: 'Tech', energy: -5, imageUrl: materialsImg, description: '-5 energy. Required to build' },
  { name: 'Tools', type: 'Tech', energy: 0, imageUrl: toolsImg, description: 'Required to build' },
  { name: 'Tools', type: 'Tech', energy: 0, imageUrl: toolsImg, description: 'Required to build' },
  { name: 'Tools', type: 'Tech', energy: 0, imageUrl: toolsImg, description: 'Required to build' },
  { name: 'Battery', type: 'Tech', energy: 0, imageUrl: batteryImg, description: 'Requires materials and tools' },
  { name: 'Battery', type: 'Tech', energy: 0, imageUrl: batteryImg, description: 'Requires materials and tools' },
  { name: 'Battery', type: 'Tech', energy: 0, imageUrl: batteryImg, description: 'Requires materials and tools' },
  { name: 'Solar Panel', type: 'Tech', energy: 7, imageUrl: solarPanelImg, description: '+7 energy. Requires battery and engineer' },
  { name: 'Solar Panel', type: 'Tech', energy: 7, imageUrl: solarPanelImg, description: '+7 energy. Requires battery and engineer' },
  { name: 'Wind Turbine', type: 'Tech', energy: 5, imageUrl: windTurbineImg, description: '+5 energy. Requires battery and engineer' },
  { name: 'Nuclear Energy', type: 'Tech', energy: 10, imageUrl: nuclearImg, description: '+10 energy. Requires battery, engineer, and physicist' },
  { name: 'Settlement', type: 'Tech', energy: -5, imageUrl: settlementImg, description: '-5 energy, +5 spaces. Requires energy source or farm.' },
  { name: 'Factory', type: 'Tech', energy: -10, imageUrl: factoryImg, description: '-10 energy. Build 3 cards for every material card played. Requires Settlement' },
  { name: 'Thriving Civilization', type: 'Tech', energy: 0, imageUrl: thrivingCivilizationImg, description: '+10 spaces. Adds a factory and city to deck. Requires city and love.' },
  // Wisdom cards
  { name: 'Engineer', type: 'Wisdom', energy: 0, imageUrl: engineerImg, description: 'Build advanced technology.' },
  { name: 'Engineer', type: 'Wisdom', energy: 0, imageUrl: engineerImg, description: 'Build advanced technology.' },
  { name: 'Meditation', type: 'Wisdom', energy: 3, imageUrl: meditationImg, description: '+3 energy' },
  { name: 'Meditation', type: 'Wisdom', energy: 3, imageUrl: meditationImg, description: '+3 energy' },
  { name: 'Curiosity', type: 'Wisdom', energy: 2, imageUrl: curiosityImg, description: '+2 energy' },
  { name: 'Curiosity', type: 'Wisdom', energy: 2, imageUrl: curiosityImg, description: '+2 energy' },
  { name: 'Observation', type: 'Wisdom', energy: 0, imageUrl: observationImg, description: 'Draw 2 cards.' },
  { name: 'Observation', type: 'Wisdom', energy: 0, imageUrl: observationImg, description: 'Draw 2 cards.' },
  { name: 'Naturalist', type: 'Wisdom', energy: 0, imageUrl: naturalistImg },
  { name: 'Naturalist', type: 'Wisdom', energy: 0, imageUrl: naturalistImg },
  { name: 'Explorer', type: 'Wisdom', energy: -5, imageUrl: explorerImg, description: '-5 energy, draw 3 cards. Requires curiosity.' },
  { name: 'Patience', type: 'Wisdom', energy: 1, imageUrl: patienceImg, description: '+1 energy. Requires meditation' },
  { name: 'Patience', type: 'Wisdom', energy: 1, imageUrl: patienceImg, description: '+1 energy. Requires meditation' },
  { name: 'Love', type: 'Wisdom', energy: 5, imageUrl: loveImg, description: '+5 energy, +1 space. Requires patience.' },
  { name: 'Community', type: 'Wisdom', energy: 5, imageUrl: communityImg, description: '+5 energy, +2 spaces, +1 hand. Requires garden or love.' },
  { name: 'Community', type: 'Wisdom', energy: 5, imageUrl: communityImg, description: '+5 energy, +2 spaces, +1 hand. Requires garden or love.' },
  { name: 'Scavenger', type: 'Wisdom', energy: 0, imageUrl: scavengerImg, description: 'Move two cards from the discard pile into your hand.' },
  { name: 'Futurist', type: 'Wisdom', energy: 0, imageUrl: futuristImg, description: 'Select a card from your deck and put it into your hand.' },
  { name: 'Physicist', type: 'Wisdom', energy: 0, imageUrl: physicistImg, description: 'Build advanced technology. Requires curiosity.' },
  { name: 'Uncharted', type: 'Eco', energy: 0, imageUrl: unchartedImg, description: '+2 spaces. Adds 2 random cards to the deck. Requires explorer.' },
];

  const cardStyle = {
	width: '100%',
	maxWidth: '200px',
	aspectRatio: '2.5/4',
	color: 'black',
	backgroundColor: 'rgba(255,255,255,0.95)',
	borderRadius: '10px',
	boxShadow: '0 5px 18px rgba(0, 0, 0, 0.3)',
	display: 'flex',
	flexDirection: 'column',
	padding: '0',
	textAlign: 'center',
	overflow: 'hidden',
	position: 'relative',
	boxSizing: 'border-box',
	transition: 'transform 0.2s ease, box-shadow 0.2s ease',
	cursor: 'pointer',
  };

  const renderDeck = (card, index,) => {
	return (
	  <div 
		style={cardStyle} 
		key={index}
		onMouseEnter={(e) => {
		  e.currentTarget.style.transform = 'scale(1.05)';
		  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.4)';
		}}
		onMouseLeave={(e) => {
		  e.currentTarget.style.transform = 'scale(1)';
		  e.currentTarget.style.boxShadow = '0 5px 18px rgba(0, 0, 0, 0.3)';
		}}
	  >
		<img 
		  src={card.imageUrl} 
		  alt={card.name} 
		  style={{
			width: '100%',
			height: '60%',
			objectFit: 'cover',
			borderRadius: '10px 10px 0 0',
		  }}
		/>
		<div style={{
		  padding: '8px',
		  height: '40%',
		  display: 'flex',
		  flexDirection: 'column',
		  justifyContent: 'space-between',
		  gap: '2px',
		}}>
		  <div style={{ fontWeight: 'bold', fontSize: '14px', lineHeight: '1.2' }}>{card.name}</div>

		  <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#444' }}>{card.description}</div>
		</div>
	  </div>
	);
  };
  
function Rules() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
		
  return (
	<>
	  <Button 
	    variant="light"
		size="lg" 
		onClick={handleShow}
		aria-label="View game rules"
		style={{
		  fontSize: 'clamp(14px, 3.5vw, 18px)',
		  padding: 'clamp(10px, 2.5vw, 16px) clamp(18px, 4vw, 28px)',
		  fontWeight: '600',
		  borderRadius: '12px',
		  transition: 'all 0.3s ease',
		}}
	  >
		Rules
	  </Button>

	  <Modal 
		className='modal' 
		show={show} 
		onHide={handleClose}
		size="xl"
		centered
		style={{ maxWidth: '95vw' }}
	  >
		<Modal.Header closeButton style={{
		  backgroundColor: 'rgba(20, 20, 30, 0.98)',
		  borderBottom: '2px solid rgba(255, 215, 0, 0.3)',
		  color: '#ffd700',
		}}>
		  <Modal.Title style={{
			fontSize: window.innerWidth < 768 ? '20px' : '28px',
			fontWeight: 'bold',
			textTransform: 'uppercase',
			letterSpacing: '2px',
			textShadow: '0 0 10px rgba(255, 215, 0, 0.5)',
		  }}>Game Rules & Cards</Modal.Title>
		</Modal.Header>
		<Modal.Body style={{
		  backgroundColor: 'rgba(10, 10, 20, 0.98)',
		  color: 'white',
		  maxHeight: '80vh',
		  overflowY: 'auto',
		  padding: '30px',
		}}>
		  {/* Solitaire Mode Rules */}
		  <div style={{ marginBottom: '40px' }}>
			<h3 style={{ 
			  color: '#ffd700', 
			  marginBottom: '20px',
			  textShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
			}}>Solitaire Mode</h3>
			<div style={{ 
			  fontSize: '16px', 
			  lineHeight: '1.8',
			  maxWidth: '900px',
			  margin: '0 auto',
			  textAlign: 'left',
			  backgroundColor: 'rgba(255, 215, 0, 0.05)',
			  padding: '20px',
			  borderRadius: '15px',
			  border: '1px solid rgba(255, 215, 0, 0.2)',
			}}>
			  <p style={{ marginBottom: '15px' }}>
				You start the game with <strong>5 cards</strong> in hand and <strong>10 spaces</strong> to play cards. 
				Each turn you will draw a card from the deck and choose to either play a card to build your environment or discard.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				The objective is to <strong>maximize the amount of energy</strong> your environment produces.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				The game is over when you have used all of your playable spaces or your deck has run out of cards.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				Cards have attributes that can produce energy, create play spaces, add more cards to your deck, and other abilities to be discovered.
			  </p>
			  <p>
				Certain cards require other cards to be played first so having an understanding of your deck is important for developing an effective strategy. 
				Every turn is a critical decision in managing spaces, card count, and energy output.
			  </p>
			</div>
		  </div>

		  {/* Versus Mode Rules */}
		  <div style={{ marginBottom: '40px' }}>
			<h3 style={{ 
			  color: '#00ff7f', 
			  marginBottom: '20px',
			  textShadow: '0 0 5px rgba(0, 255, 127, 0.3)',
			}}>Versus Mode</h3>
			<div style={{ 
			  fontSize: '16px', 
			  lineHeight: '1.8',
			  maxWidth: '900px',
			  margin: '0 auto',
			  textAlign: 'left',
			  backgroundColor: 'rgba(0, 255, 127, 0.05)',
			  padding: '20px',
			  borderRadius: '15px',
			  border: '1px solid rgba(0, 255, 127, 0.2)',
			}}>
			  <p style={{ marginBottom: '15px' }}>
				<strong>Versus mode</strong> is a competitive two-player game where you face off against an AI opponent. 
				Both players take turns playing cards to build their environments.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				<strong>Turn-Based Play:</strong> Players alternate turns. On your turn, you can play a card from your hand or discard it.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				<strong>Shared Cards:</strong> You can play cards from your opponent's discard pile! When you do, these cards go to a 
				<span style={{ color: '#9b59b6', fontWeight: 'bold' }}> shared area</span> in the center. Both players can use shared cards 
				as prerequisites, but only the player who played it gets the card's energy and special effects.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				<strong>Wisdom Restriction:</strong> Wisdom cards (except <span style={{ color: '#ffd700' }}>Love</span>) cannot be played 
				from your opponent's discard pile - they must be earned from your own deck.
			  </p>
			  <p style={{ marginBottom: '15px' }}>
				<strong>Winning:</strong> The game ends when both players have exhausted their decks or filled all their spaces. 
				The player with the <strong>highest energy score wins!</strong>
			  </p>
			  <p>
				<strong>Strategy Tip:</strong> Watch your opponent's discard pile for valuable cards you can use. 
				Balance building your own engine with denying your opponent key prerequisite cards.
			  </p>
			</div>
		  </div>

		  {/* Key Concepts */}
		  <div style={{ marginBottom: '40px' }}>
			<h3 style={{ 
			  color: '#87ceeb', 
			  marginBottom: '20px',
			  textShadow: '0 0 5px rgba(135, 206, 235, 0.3)',
			}}>Key Concepts</h3>
			<div style={{
			  display: 'grid',
			  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
			  gap: '15px',
			  maxWidth: '900px',
			  margin: '0 auto',
			}}>
			  <div style={{
				backgroundColor: 'rgba(255, 193, 7, 0.1)',
				padding: '15px',
				borderRadius: '10px',
				border: '1px solid rgba(255, 193, 7, 0.3)',
			  }}>
				<h4 style={{ color: '#ffc107', margin: '0 0 8px 0', fontSize: '16px' }}>Energy</h4>
				<p style={{ margin: 0, fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)' }}>
				  Your score! Cards add or subtract energy. Maximize your total to win.
				</p>
			  </div>
			  <div style={{
				backgroundColor: 'rgba(0, 255, 127, 0.1)',
				padding: '15px',
				borderRadius: '10px',
				border: '1px solid rgba(0, 255, 127, 0.3)',
			  }}>
				<h4 style={{ color: '#00ff7f', margin: '0 0 8px 0', fontSize: '16px' }}>Spaces</h4>
				<p style={{ margin: 0, fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)' }}>
				  Limited slots for cards. Start with 10, some cards grant more.
				</p>
			  </div>
			  <div style={{
				backgroundColor: 'rgba(135, 206, 235, 0.1)',
				padding: '15px',
				borderRadius: '10px',
				border: '1px solid rgba(135, 206, 235, 0.3)',
			  }}>
				<h4 style={{ color: '#87ceeb', margin: '0 0 8px 0', fontSize: '16px' }}>Prerequisites</h4>
				<p style={{ margin: 0, fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)' }}>
				  Many cards require other cards to be played first. Plan your sequence!
				</p>
			  </div>
			  <div style={{
				backgroundColor: 'rgba(155, 89, 182, 0.1)',
				padding: '15px',
				borderRadius: '10px',
				border: '1px solid rgba(155, 89, 182, 0.3)',
			  }}>
				<h4 style={{ color: '#9b59b6', margin: '0 0 8px 0', fontSize: '16px' }}>Card Types</h4>
				<p style={{ margin: 0, fontSize: '14px', color: 'rgba(255, 255, 255, 0.8)' }}>
				  Wisdom (purple), Ecology (green), and Technology (blue) each have unique chains.
				</p>
			  </div>
			</div>
		  </div>
		
		  <div style={{ marginTop: '40px' }}>
			<h3 style={{ 
			  color: '#ffd700', 
			  marginBottom: '25px',
			  textShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
			}}>Card Collection</h3>
			
			{/* Card categories */}
			<div style={{ marginBottom: '40px' }}>
			  <h4 style={{ color: '#87ceeb', marginBottom: '20px' }}>Wisdom Cards</h4>
			  <div style={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
				gap: '20px',
				justifyItems: 'center',
				marginBottom: '30px',
			  }}>
				{availableCards.filter(card => card.type === 'Wisdom').map((card, index) => renderDeck(card, index))}
			  </div>
			</div>
			
			<div style={{ marginBottom: '40px' }}>
			  <h4 style={{ color: '#90ee90', marginBottom: '20px' }}>Ecology Cards</h4>
			  <div style={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
				gap: '20px',
				justifyItems: 'center',
				marginBottom: '30px',
			  }}>
				{availableCards.filter(card => card.type === 'Eco').map((card, index) => renderDeck(card, index))}
			  </div>
			</div>
			
			<div style={{ marginBottom: '40px' }}>
			  <h4 style={{ color: '#ff6b6b', marginBottom: '20px' }}>Technology Cards</h4>
			  <div style={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
				gap: '20px',
				justifyItems: 'center',
				marginBottom: '30px',
			  }}>
				{availableCards.filter(card => card.type === 'Tech').map((card, index) => renderDeck(card, index))}
			  </div>
			</div>
		  </div>
		</Modal.Body>
		<Modal.Footer style={{
		  backgroundColor: 'rgba(20, 20, 30, 0.98)',
		  borderTop: '2px solid rgba(255, 215, 0, 0.3)',
		  padding: '20px',
		  display: 'flex',
		  justifyContent: 'center',
		}}>
		  <Button 
			variant="warning" 
			onClick={handleClose}
			style={{
			  padding: '10px 30px',
			  fontSize: '16px',
			  fontWeight: 'bold',
			  borderRadius: '25px',
			  backgroundColor: '#ffd700',
			  border: 'none',
			  color: '#000',
			  textTransform: 'uppercase',
			  letterSpacing: '1px',
			  transition: 'all 0.3s ease',
			}}
			onMouseEnter={(e) => {
			  e.currentTarget.style.transform = 'scale(1.05)';
			  e.currentTarget.style.boxShadow = '0 0 20px rgba(255, 215, 0, 0.5)';
			}}
			onMouseLeave={(e) => {
			  e.currentTarget.style.transform = 'scale(1)';
			  e.currentTarget.style.boxShadow = 'none';
			}}
		  >
			Close
		  </Button>
		</Modal.Footer>
	  </Modal>
	</>
  );
}

export default Rules;